import * as React from 'react';

const SurveyForm = (props) => {
  const { SetStatus, data } = props;
  const renderQuestion = (question, placeholder, withClass = true) => (
    <div className='survey-content' style={withClass ? {} : { borderBottom: 0, paddingBottom: 0 }}>
      <div className='font-arial font-15 mb-2'>
        <strong>{question.forM_QUESTION_TX}</strong>
      </div>
      <div className="form-group mb-0">
        <label htmlFor="response">Response:</label>
        <input
          type="text"
          disabled={true}
          name="response"
          placeholder={placeholder}
          className="form-control form-control-sm"
          defaultValue={question.forM_ANSWER_TX}
        />
      </div>
    </div>
  );

  // Function to render address information
  const renderAddress = (item, heading) => (
    <div className='survey-content'>
      <p className='font-arial font-15 mb-1'>{heading}</p>
      <p className='font-arial font-13 mb-1 mt-0'>
        Company: {item.resalE_COMPANY_NM} <br />
        Address1: {item.resalE_ADDRESS_TX_01} <br />
        Address2: {item.resalE_ADDRESS_TX_02 || ''} <br />
        City, State: {item.resalE_CITY_NM}, {item.resalE_STATE_NM} <br />
        Postal Code: {item.resalE_POSTAL_CD} <br />
        Country: {item.resalE_COUNTRY_NM}
      </p>
    </div>
  );

  const getDependentQuestion = (parentQuestionId) => {
    return data?.data?.find(q => q.parenT_QUESTION_ID === parentQuestionId);
  };


  return (
    <>
      <div className="avnet-modal modal-730 surveyresponse">
        <div className="avnet-modal-inner">
          {/* Modal Header */}
          <button type="button" className="close py-3" data-dismiss="modal"
            onClick={() => {
              SetStatus(false)
            }}>×
          </button>
          <div className="modal-header justify-content-center mt-0">
            <h3 className="pcn-modal-heading pl-5">Survey Response</h3>
          </div>

          {/* Modal body */}
          <div className="modal-body">
            <div className="clearfix" />
            {data?.data?.map(item => {
              if (item.forM_QUESTION_ID === 134) {
                if (item.forM_ANSWER_TX === 'Other') {
                  const dependentQuestion = getDependentQuestion(134);
                  return (
                    <div key={item.forM_QUESTION_ID}>
                      {renderQuestion(item, 'Contract Manufacturer of electronic components')}
                      {dependentQuestion && renderQuestion(dependentQuestion, 'Other details')}
                    </div>
                  );
                }
                return (
                  <div key={item.forM_QUESTION_ID}>
                    {renderQuestion(item, 'Contract Manufacturer of electronic components')}
                  </div>
                );
              }

              // Render question 136
              if (item.forM_QUESTION_ID === 136 && item.forM_ANSWER_TX) {
                return (
                  <div key={item.forM_QUESTION_ID}>
                    {renderQuestion(item, 'Military')}
                  </div>
                );
              }

              // Render question 138 and 139
              if (item.forM_QUESTION_ID === 138) {
                if (item.forM_ANSWER_TX === 'Y') {
                  const dependentQuestion = getDependentQuestion(138);
                  return (
                    <div key={item.forM_QUESTION_ID}>
                      {renderQuestion(item, 'Y', !dependentQuestion)}
                      {dependentQuestion && (
                        <div>
                          {renderAddress(dependentQuestion, "Shipping Address:")}
                        </div>
                      )}
                    </div>
                  );
                }
                return (
                  <div key={item.forM_QUESTION_ID}>
                    {renderQuestion(item, 'N')}
                  </div>
                );
              }

              // Render question 161 and 162
              if (item.forM_QUESTION_ID === 161) {
                if (item.forM_ANSWER_TX === 'Y') {
                  const dependentQuestion = getDependentQuestion(161);
                  return (
                    <div key={item.forM_QUESTION_ID}>
                      {renderQuestion(item, 'Y', !dependentQuestion)}
                      {dependentQuestion && (
                        <div>
                          {renderAddress(dependentQuestion, "Ultimate Consignee:")}
                        </div>
                      )}
                    </div>
                  );
                }
                return (
                  <div key={item.forM_QUESTION_ID}>
                    {renderQuestion(item, 'N')}
                  </div>
                );
              }

              // Render question 170
              if (item.forM_QUESTION_ID === 170 && item.forM_ANSWER_TX === 'I Agree') {
                return (
                  <div key={item.forM_QUESTION_ID}>
                    <div className='font-arial font-13 mb-2'>
                      <strong>{item.forM_QUESTION_TX}</strong>
                    </div>
                    <div className="form-group">
                      <label htmlFor="response">Response:</label>
                      <input
                        type="text"
                        name="response"
                        disabled={true}
                        placeholder='I Agree'
                        className="form-control form-control-sm"
                        defaultValue={item.forM_ANSWER_TX}
                      />
                    </div>
                  </div>
                );
              }

              return null;
            })}
          </div>


          {/* Modal footer */}
          <div className="modal-footer text-center">
            <div className="modal-footer-actions">
              <button type="button" className="bs5 btn btn-secondary w145" data-dismiss="modal"
                onClick={() => {
                  SetStatus(false)
                }}>
                Close
              </button>
            </div>
          </div>


        </div>
      </div>
    </>
  );
}

export default SurveyForm;
